import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";

const Component = loadable(() =>
    import("@lexus.com/ui/dist/components/GalleryCarousel")
);

const ComponentEditConfig = {
    emptyLabel: "Gallery Carousel",
    isEmpty: function (props) {
        return !props || !props.title || props.title.trim().length < 1;
    },
};

const transformData = (props) => {
    const tabs = [];

    if (props?.tabs && props?.tabs?.length > 0) {
        props.tabs.forEach((tab) => {
          const { slides } = tab;
          const transformedSlides = [];

          if (slides && slides?.length > 0) {
            slides.forEach((slide) => {
                const transFormedSlide = {
                  id: slide?.id,
                  variant: tab?.variant,
                  copyBackgroundColor:
                    slide?.copyBoxColor || tab?.copyBackgroundColor,
                  copyBackgroundOpacity:
                    slide?.copyBoxOpacity || tab?.copyBackgroundOpacity,
                  copyPosition: slide?.copyPosition,
                  copyWidth:
                    slide?.copyBoxSize === "half"
                      ? "1/2"
                      : slide?.copyBoxSize === "third"
                      ? "1/3"
                      : undefined,
                  textColor: slide?.copyTextColor || tab?.textColor,
                  lineColor: slide?.lineColor || tab?.textColor,
                  size: slide?.size || tab?.size,
                  title: slide?.title,
                  description: slide?.description,
                  media: slide?.media,
                  ctas: slide?.ctas,
                };

                transformedSlides.push(transFormedSlide);
            });
          }

          const transformedTab = {
            id: tab?.id,
            title: tab?.title,
            variant: tab?.variant,
            size: tab?.size,
            slides: transformedSlides,
            textColor: tab?.textColor,
            copyBackgroundColor: tab?.copyBackgroundColor,
            copyBackgroundOpacity: tab?.copyBackgroundOpacity,
            enableFullScreen: props?.enableFullScreen,
          };
          tabs.push(transformedTab);
        });
    }
    
    return ({
        component: "GalleryCarousel",
        props: {
            id: props?.id,
            heading: props?.heading,
            headingColor: props?.headingColor,
            subHeading: props?.subHeading,
            subHeadingColor: props?.subHeadingColor,
            tabs,
            theme: props?.theme,
            enableFullScreen: props?.enableFullScreen,
        }
    })
}

const GalleryCarousel = (props) => {
    const data = transformData(props) ?? {};
    return <Component {...data?.props} />
};

export default withAemIntegration("lexus/components/content/gallery-carousel")(
    GalleryCarousel,
    ComponentEditConfig
);
